// Third-party imports
import Cookie from 'js-cookie';

// Local imports
import { PAGE_VARS, PageKind } from '../page/vars.js';
import { enum_value } from '../util/enumtool.js';
import * as worldvision from '../global/worldvision.js';

export function setMotCodeCookie(value) {
    //check if motcode cookie exists
    let cookieExists = Cookie.get('mot_code');

    if (!cookieExists || value) {
        const cookeExpiryDays = new Date();
        // Setting the cookie expiration days as 15 days as part of user story DIT-19257
        cookeExpiryDays.setTime(cookeExpiryDays.getTime() + (15*24*60*60*1000));  
        Cookie.set('mot_code', value, { path: '/', expires: cookeExpiryDays });

        let siteName = enum_value(PAGE_VARS.kind);
        Cookie.set('siteName', siteName, { path: '/',expires: cookeExpiryDays });
    }
}

export function getParameterByName(global) {
    let url_params = worldvision.get_obj(global, 'url_params');
    let mot_code_obj = {};
    for (let [key, value] of Object.entries(url_params)) {
        if (key.match(/^(mot_code|mc)$/i) && value.match(/^\d+$/)) {
            mot_code_obj[key.toLowerCase()] = value;
        }
    }

    let mc = 'mc' in mot_code_obj ? mot_code_obj.mc : '';
    let mot_code = 'mot_code' in mot_code_obj ? mot_code_obj.mot_code : '';
    let value = mot_code ? mot_code : mc;
    

    if (!value) {  
        let cookieMotcode =  getCookie('mot_code');
         //If the cookie has mot code value then get it from cookie and return the same 
        if(cookieMotcode) {
            value = cookieMotcode;
        }      
        else if (PAGE_VARS.kind === PageKind.GiftCatalogue) {
            value = global.document.body.dataset.ogcDefaultMotCode;
        }
    }    

    return value;
}

export function getCookie(cookieName) {
    return Cookie.get(cookieName);
}

export function setMotCodeInputValue(global, value) {
    //assign mot_code to all elements with motcode-input class
    let motcode_val =
        typeof value === 'undefined' ? getCookie('mot_code') : value;

    // Try to get all of the mot code input elements on the page by class
    // This is valid on OGC pages, not ODN
    let all_motcode_input = global.document.querySelectorAll('.motcode-input');
    // If we found mot code input elements, i.e. are on an OGC page
    if (all_motcode_input && all_motcode_input.length > 0) {
        for (let el of all_motcode_input) {
            el.value = motcode_val;
        }
    } else {
        // We did not find any OGC specific mot code input fields, so we try for ODN
        let motCodeInputElement = global.document.getElementById(
            'mot_codeInput'
        );
        motCodeInputElement.value = motcode_val;
    }
}
